import type { ElementType, HTMLAttributes, ReactNode } from 'react';

export type SpaceStep = 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16;
export type AlignValue = 'start' | 'center' | 'end' | 'stretch' | 'baseline';
export type JustifyValue = 'start' | 'center' | 'end' | 'between';

export interface StackProps extends HTMLAttributes<HTMLElement> {
  /** Abstand als Schritt des 4-px-Rasters. */
  gap?: SpaceStep;
  align?: AlignValue;
  justify?: JustifyValue;
  /** Waagrecht statt senkrecht. Bricht bei Platzmangel um. */
  row?: boolean;
  /** Umbruch abschalten — nur wo das Ergebnis auf 360 px noch passt. */
  nowrap?: boolean;
  as?: ElementType;
  children: ReactNode;
}

/**
 * Abstand zwischen Geschwistern.
 *
 * Das ersetzt die verstreuten `style={{ gap: 'var(--space-6)' }}`, die sich
 * ueber die Seiten gezogen haben. Abstaende kommen ausschliesslich aus dem
 * Raster — eine freie Pixelzahl gibt es hier nicht, weil sie sonst genau die
 * Uneinheitlichkeit erzeugt, die dieser Umbau beseitigt.
 *
 * Waagrechte Stapel brechen standardmaessig um. Auf 360 px Breite ist eine
 * Reihe aus drei Knoepfen sonst der haeufigste Grund fuer waagrechtes
 * Scrollen der ganzen Seite.
 */
export function Stack({
  gap = 4,
  align,
  justify,
  row = false,
  nowrap = false,
  as: Tag = 'div',
  children,
  className,
  ...rest
}: StackProps) {
  return (
    <Tag
      {...rest}
      className={`stack ${className ?? ''}`.trim()}
      data-gap={gap}
      data-row={row || undefined}
      data-nowrap={nowrap || undefined}
      data-align={align}
      data-justify={justify}
    >
      {children}
    </Tag>
  );
}
